<template>
  <ll-modal
    :open="props.open"
    :loading="props.loading"
    :title="props.title"
    :confirm-text="props.confirmText"
    :cancel-text="props.cancelText"
    :width="500"
    :root-class-name="bem.b()"
    :class="'confirm-modal'"
    @cancel="props.onCancel"
    @ok="props.onConfirm"
  >
    <slot>
      <div :class="bem.e('wrapper')">
        <div :class="bem.e('container')">
          <ll-icon
            v-bind="
              props.icon || {
                iconName: 'icon-warning',
                color: warningColor,
                class: ['mr-20px'],
                style: { 'font-size': '30px' },
              }
            "
          />
          <slot name="message">
            <span :class="bem.e('text')">
              {{ props.message }}
            </span>
          </slot>
        </div>
        <slot name="extra"> </slot>
      </div>
    </slot>
  </ll-modal>
</template>

<script setup lang="ts">
import { LlModal, LlIcon } from '@ll-plus/components'
import { theme } from 'ant-design-vue'
import { secondConfirmationProps } from './second-confirmation'
import { createNamespace } from '@ll-plus/utils'
defineOptions({ name: 'LlSecondConfirmation' })
const bem = createNamespace('second-confirmation')
const props = defineProps(secondConfirmationProps)

const warningColor = theme.defaultConfig.token.colorWarning
</script>
